import Dashboard from "../app/dispatch/dashboard/dashboard.jsx";
import DutyInformation from "../app/dispatch/duty-information/duty-information.jsx";
import ScheduleAttendanceCalendar from "../app/dispatch/schedule-attendance-calendar/schedule-attendance-calendar.jsx";
import PriorityList from "../app/dispatch/priority/priority-list.jsx";
import PriorityForm from "../app/dispatch/priority/form/priority-form.jsx";
import ProvidenceList from "../app/dispatch/providence/providence-list.jsx";
import ProvidenceForm from "../app/dispatch/providence/form/providence-form.jsx";
import AttendanceStatusList from "../app/dispatch/attendance-status/attendance-status-list.jsx";
import AttendanceStatusForm from "../app/dispatch/attendance-status/form/attendance-status-form.jsx";
import ReservationCauseList from "../app/dispatch/reservation-cause/reservation-cause-list.jsx";
import ReservationCauseForm from "../app/dispatch/reservation-cause/form/reservation-cause-form.jsx";
import CompositionList from "../app/dispatch/composition/composition-list.jsx";
import CompositionForm from "../app/dispatch/composition/form/composition-form.jsx";
import AttendanceChannelList from "../app/dispatch/attendance-channel/attendance-channel-list.jsx";
import AttendanceChannelForm from "../app/dispatch/attendance-channel/form/attendance-channel-form.jsx";
import FixedLocationInspection from "../app/dispatch/fixed-location-inspection/fixed-location-inspection.jsx";
import ActivityList from "../app/dispatch/activity/activity-list.jsx";
import ActivityForm from "../app/dispatch/activity/form/activity-form.jsx";
import AttendanceList from "../app/dispatch/attendance/attendance-list.jsx";
import AttendanceForm from "../app/dispatch/attendance/form/attendance-form.jsx";
import GarrisonList from "../app/dispatch/garrison/garrison-list.jsx";
import GarrisonForm from "../app/dispatch/garrison/form/garrison-form.jsx";
import DispatchList from "../app/dispatch/dispatch/dispatch-list.jsx";
import DispatchForm from "../app/dispatch/dispatch/form/dispatch-form.jsx";
import ScheduleGarrisonList from "../app/dispatch/schedule-garrison/schedule-garrison-list.jsx";
import ScheduleGarrisonForm from "../app/dispatch/schedule-garrison/form/schedule-garrison-form.jsx";
import ScheduleAttendanceList from "../app/dispatch/schedule-attendance/schedule-attendance-list.jsx";
import ScheduleAttendanceForm from "../app/dispatch/schedule-attendance/form/schedule-attendance-form.jsx";
import GarrisonTimeline from "../app/dispatch/garrison-timeline/garrison-timeline.jsx";
import GarrisonTimelinePrint from "../app/dispatch/garrison-timeline/garrison-timeline-print.jsx";
import GarrisonRouteView from "../app/dispatch/garrison-timeline/garrison-route-view.jsx";
import {requirePermission} from "./middleware.js";
import {PermissionEnum} from "../utils/enums/permission-enum.js";

const ADMIN = PermissionEnum.DISPATCH_ADMIN;
const ACTIVITY = [PermissionEnum.DISPATCH_ACTIVITY, PermissionEnum.DISPATCH_ACTIVITY_SUBORDINATES];
const ATTENDANCE = [PermissionEnum.ATTENDANCE_WEB, PermissionEnum.ATTENDANCE_VISUALIZATION];
const GARRISON = [PermissionEnum.GARRISON_WEB, PermissionEnum.MY_GARRISON, PermissionEnum.RETROACTIVE];
const DISPATCH = [PermissionEnum.DISPATCH_DISPATCH, PermissionEnum.RETROACTIVE];

const RouterDispatch = () => [
    {
        id: "dispatch-dashboard",
        path: "dashboard",
        Component: Dashboard,
        loader: requirePermission(PermissionEnum.DISPATCH)
    },

    {
        id: "duty-information",
        path: "duty-information",
        Component: DutyInformation,
        loader: requirePermission(PermissionEnum.DUTY_INFORMATION)
    },

    {
        id: "schedule-attendance-calendar",
        path: "schedule-attendance-calendar",
        Component: ScheduleAttendanceCalendar,
        loader: requirePermission(PermissionEnum.ATTENDANCE_SCHEDULE_CALENDAR)
    },

    {
        id: "dispatch-priority",
        path: "priority",
        Component: PriorityList,
        loader: requirePermission(ADMIN)
    },
    {
        id: "dispatch-priority-form",
        path: "priority/form/:id?",
        Component: PriorityForm,
        loader: requirePermission(ADMIN)
    },

    {
        id: "dispatch-providence",
        path: "providence",
        Component: ProvidenceList,
        loader: requirePermission(ADMIN)
    },
    {
        id: "dispatch-providence-form",
        path: "providence/form/:id?",
        Component: ProvidenceForm,
        loader: requirePermission(ADMIN)
    },

    {
        id: "dispatch-attendance-status",
        path: "attendance-status",
        Component: AttendanceStatusList,
        loader: requirePermission(ADMIN)
    },
    {
        id: "dispatch-attendance-status-form",
        path: "attendance-status/form/:id?",
        Component: AttendanceStatusForm,
        loader: requirePermission(ADMIN)
    },

    {
        id: "dispatch-reservation-cause",
        path: "reservation-cause",
        Component: ReservationCauseList,
        loader: requirePermission(ADMIN)
    },
    {
        id: "dispatch-reservation-cause-form",
        path: "reservation-cause/form/:id?",
        Component: ReservationCauseForm,
        loader: requirePermission(ADMIN)
    },

    {
        id: "dispatch-composition",
        path: "composition",
        Component: CompositionList,
        loader: requirePermission(ADMIN)
    },
    {
        id: "dispatch-composition-form",
        path: "composition/form/:id?",
        Component: CompositionForm,
        loader: requirePermission(ADMIN)
    },

    {
        id: "dispatch-attendance-channel",
        path: "attendance-channel",
        Component: AttendanceChannelList,
        loader: requirePermission(ADMIN)
    },
    {
        id: "dispatch-attendance-channel-form",
        path: "attendance-channel/form/:id?",
        Component: AttendanceChannelForm,
        loader: requirePermission(ADMIN)
    },

    {
        id: "dispatch-fixed-location-inspection",
        path: "fixed-location-inspection",
        Component: FixedLocationInspection,
        loader: requirePermission(ADMIN)
    },

    {
        id: "dispatch-activity",
        path: "activity",
        Component: ActivityList,
        loader: requirePermission(ACTIVITY)
    },
    {
        id: "dispatch-activity-form",
        path: "activity/form/:id?",
        Component: ActivityForm,
        loader: requirePermission(ACTIVITY)
    },

    {
        id: "dispatch-attendance",
        path: "attendance",
        Component: AttendanceList,
        loader: requirePermission(ATTENDANCE)
    },
    {
        id: "dispatch-attendance-form",
        path: "attendance/form/:id?",
        Component: AttendanceForm,
        loader: requirePermission(ATTENDANCE)
    },

    {
        id: "dispatch-garrison",
        path: "garrison",
        Component: GarrisonList,
        loader: requirePermission(GARRISON)
    },
    {
        id: "dispatch-garrison-form",
        path: "garrison/form/:id?",
        Component: GarrisonForm,
        loader: requirePermission(GARRISON)
    },
    {
        id: "dispatch-garrison-retroactive",
        path: "garrison/retroactive",
        Component: GarrisonForm,
        loader: requirePermission(PermissionEnum.RETROACTIVE)
    },

    {
        id: "dispatch-dispatch",
        path: "dispatch",
        Component: DispatchList,
        loader: requirePermission(DISPATCH)
    },
    {
        id: "dispatch-dispatch-form",
        path: "dispatch/form/:id?",
        Component: DispatchForm,
        loader: requirePermission([...DISPATCH, PermissionEnum.MY_GARRISON])
    },
    {
        id: "dispatch-dispatch-retroactive",
        path: "dispatch/retroactive",
        Component: DispatchForm,
        loader: requirePermission(PermissionEnum.RETROACTIVE)
    },

    {
        id: "dispatch-schedule-garrison",
        path: "schedule-garrison",
        Component: ScheduleGarrisonList,
        loader: requirePermission(PermissionEnum.GARRISON_SCHEDULE)
    },
    {
        id: "dispatch-schedule-garrison-form",
        path: "schedule-garrison/form/:id?",
        Component: ScheduleGarrisonForm,
        loader: requirePermission(PermissionEnum.GARRISON_SCHEDULE)
    },

    {
        id: "dispatch-schedule-attendance",
        path: "schedule-attendance",
        Component: ScheduleAttendanceList,
        loader: requirePermission(PermissionEnum.ATTENDANCE_SCHEDULE)
    },
    {
        id: "dispatch-schedule-attendance-form",
        path: "schedule-attendance/form/:id?",
        Component: ScheduleAttendanceForm,
        loader: requirePermission(PermissionEnum.ATTENDANCE_SCHEDULE)
    },
    {
        id: "garrison-timeline",
        path: "garrison-timeline",
        Component: GarrisonTimeline,
        loader: requirePermission(PermissionEnum.GARRISON_TIMELINE)
    },
    {
        id: "garrison-timeline-print",
        path: "garrison-timeline/print",
        Component: GarrisonTimelinePrint,
        loader: requirePermission(PermissionEnum.GARRISON_TIMELINE)
    },
    {
        id: "garrison-timeline-route",
        path: "garrison-timeline-route/:id",
        Component: GarrisonRouteView,
        loader: requirePermission(PermissionEnum.GARRISON_TIMELINE)
    },
];

export default RouterDispatch;
